import React from 'react'
import PropTypes from 'prop-types'

/**
 * PageHeader
 *
 * Header component for pages optional left component, centered logo, and right component.
 *
 * @param {Object} props
 * @param {string|React.ReactNode} props.logo - Logo (URL string or React element)
 * @param {React.ReactNode} props.leftComponent - Left component (e.g., back button)
 * @param {React.ReactNode} props.rightComponent - Right component (e.g., progress indicator)
 * @param {string} props.className - Additional CSS classes
 */
const PageHeader = ({
  logo,
  leftComponent,
  rightComponent,
  className = ''
}) => {
  return (
    <header className={`sticky top-0 z-10 px-4 py-12 bg-background ${className}`}>
      <div className="container mx-auto max-w-6xl">
        <div className="grid items-center grid-cols-3 gap-4">
          {/* Left: Optional Component */}
          <div className="flex-shrink-0 w-24">
            {leftComponent}
          </div>

          {/* Center: Logo */}
          <div className="flex-shrink-0 justify-self-center">
            {typeof logo === 'string' ? (
              <img src={logo} alt="Logo" className="h-8" />
            ) : (
              logo
            )}
          </div>

          {/* Right: Optional Component */}
          <div className="flex-shrink-0 w-[15vw] sm:w-[25vw] md:w-64 flex justify-end justify-self-end">
            {rightComponent}
          </div>
        </div>
      </div>
    </header>
  )
}

PageHeader.propTypes = {
  logo: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  leftComponent: PropTypes.node,
  rightComponent: PropTypes.node,
  className: PropTypes.string
}

export default PageHeader